export default [
  {
    path: '/tickets',
    component: () => import(/* webpackChunkName: "tickets" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
    },
  },
];
